<div class="toolbar">
  <div class="float-left" [ngClass]="{'mobilehide': timeRemaining !== null}">
    <h2 class="logo ml-2">
      <a style="color: white !important; cursor: pointer;" routerLink="/exam/userexams" aria-label="Go to Scheduled Exams Dashboard">
        <img src="/assets/images/main-logo.png" width="180" alt="WebTest" />
      </a>
    </h2>
  </div>
  <div class="spacer h5 d-flex justify-content-between align-items-center w-100">
    <span class="ml-5 mobilehide" style="color: white !important;" aria-live="polite">
      <span class="welcome">{{language.welcome}},</span>
      <span class="user_name">{{this.user.fullname}}</span>
    </span>
  
    <div class="d-flex mobile-full-width align-items-center justify-content-between">
      <div class="d-flex flex-row align-items-center" [ngClass]="{'mr-5': !shouldShowCountdown}" *ngIf="timeRemaining !== null">
        <div class="zoom-controls mobilehide d-flex align-items-center"  role="group" [attr.aria-label]="language.zoomControls">
          <button (click)="zoomQuestionIn()" class="btn btn-light me-2" [title]="language.zoomIn">
            <svg style="transform: scaleY(1.2);" height="18" width="18" clip-rule="evenodd" fill-rule="evenodd" aria-hidden="true" focusable="false"
              stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(-400 -240)">
                <g transform="translate(2.148 -.042)">
                  <path
                    d="m413.668 282.042h18.664l4.547 12h6.416l-16.689-44.042h-7.212l-16.689 44.042h6.416zm2.653-7h13.358l-6.679-17.626zm22.922-9.421 6.757-6.757s6.757 6.757 6.757 6.757l4.243-4.242-11-11-11 11z" />
                </g>
              </g>
            </svg>
          </button>
  
          <button (click)="zoomQuestionOut()" class="btn btn-light"  [title]="language.zoomOut">
            <svg style="transform: scaleY(1.2); opacity: 0.6;" height="18" width="18" clip-rule="evenodd" aria-hidden="true" focusable="false"
              fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg">
              <g transform="translate(-480 -240)">
                <path
                  d="m516.811 291-11.241-29.663h-6.113l-11.24 29.663h6.417l2.645-6.981h10.47l2.645 6.981zm-16.88-13.981h5.165l-2.582-6.816zm18.094-24.019 6.758 6.757s6.757-6.757 6.757-6.757l4.243 4.243-11 11-11-11z" />
              </g>
            </svg>
          </button>
        </div>
  
        <div class="timer-wrap text-center" tabindex="0" [attr.aria-label]="countdownCurrentTimeMessage" *ngIf="shouldShowCountdown">
          <div #countdownWrapper>
            <countdown #countdown [config]="{ leftTime: timeRemaining, notify: timeLeftNotificationInterval}"
              (event)="countDownEventHandler($event)">
            </countdown>
          </div>
          <div class="sr-only" aria-live="assertive" aria-atomic="true">
            {{ countdownNotifyMessage }}
          </div>
        </div>
      </div>
      <div>
        <span style="color: white !important; margin-right: 2vw;">
          <a style="color: white !important; cursor: pointer;"  [attr.aria-label]="language.logoutFromTheCurrentSession" (click)="openLogoutConfirmModal(logoutConfirmModal)">
            <i class="fa fa-sign-out" aria-hidden="true"></i> {{language.logout}}
          </a>
        </span>
      </div>
    </div>
  </div>
  
</div>

<!-- Main Content with Sidebar and Content Areas -->
<div class="container-fluid">
  <div class="overlay" [ngClass]="{'show': loading}"></div>
  <div class="spanner" [ngClass]="{'show': loading}">
    <div class="spin-wrap">
      <div class="spin-wrap-content">
        <div class="spinner-container">
          <div class="lds-ripple"></div>
        </div>
      </div>
    </div>
  </div>

  <div class="inner_exam_wrap">
    <div class="row" style="min-height: calc(100dvh - 4.375rem - {{sebQuitHeight}});">
      <!-- Mobile Accordion -->
      <div class="mobile my-2">
        <div class="accordion" id="mobileaccordion">
          <div class="card-header p-2" id="passportsectionmobile" data-toggle="collapse"
            data-target="#passportsectionmobilecollapse" aria-expanded="false"
            aria-controls="#passportsectionmobilecollapse">
            <h5 class="mb-0">
              <span> {{language.passportSection}}</span>
            </h5>
          </div>
          <div id="passportsectionmobilecollapse" class="collapse " aria-labelledby="#passportsectionmobile"
            data-parent="#mobileaccordion">
            <div class="card-body">
              <div class="col-md-2 border border-right usericon">
                <!-- Card body -->
                <div class="mt-2">
                  <div class="row mb-1">
                    <div class="col-md-12">
                      <div class="user_profile_wrap">
                        <h6 *ngIf="togglepassportui" style="text-align: center; font-weight:bold;">
                          {{language.maxFileUpload1mb}}
                        </h6>
                        <img *ngIf="imageUrl" [src]="imageUrl" class="rounded img-center img-fluid"
                          style="width: 160px;" [alt]="language.passport">
                        <div *ngIf="canUploadPassport">
                          <h6 *ngIf="showlimittext" style="text-align: center;" class="text-danger">{{limittext}}</h6>
                          <input *ngIf="togglepassportui" accept="image/png, image/jpeg" type="file"
                            (change)="onFileChange($event)" style="margin-top:8px" [attr.aria-label]="language.uploadPassport"/>
                          <button (click)="showwebcammodal()" class="d-flex justify-content-around align-items-center"
                            style="background-color: #74bbf7; width: 90%; padding-left: 2px; padding-right: 2px; margin: 5px auto; border-radius: 5px; cursor: pointer; border:none;" [attr.aria-label]="language.openWebcamForPassport">
                            <i class="fa fa-camera" aria-hidden="true"></i>
                            <p style="font-weight:bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                              {{language.takePicture}}</p>
                          </button>
                        </div>
                        <div *ngIf="isInIframe()" class="candidate-video-div">
                          <video class="candidate-video" #candidateVideo playsinline autoplay muted></video>
                          <div class="text-info text-center">
                            <ul>
                              <li> <b>{{language.clearFaceInstruction}}</b></li>
                              <!-- <li> {{language.brightLightInstruction}}</li> -->
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col text-center">
                    <button title="Requests Attention" (click)="raiseHandClicked()"
                      class="btn btn-sm btn-primary p-1 m-2" *ngIf="isProctorAssigned()">
                      {{language.requestAttention}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar (Desktop) with Content -->
      <div class="col-md-4 col-lg-3 col-xl-3 desktop left-div border border-right desk">
        <!-- Card body -->
        <div class="d-flex flex-column h-100">
          <div class="d-flex mb-1" style="height: calc(100% - 80px); padding: 10px; padding-bottom: 0px; overflow-y: auto;">
            <div class="w-100">
              <div class="user_profile_wrap">
                <h6 *ngIf="togglepassportui" style="text-align: center; font-weight:bold;">
                  {{language.maxFileUpload1mb}}
                </h6>
                <img *ngIf="imageUrl" [src]="imageUrl" class="rounded img-center img-fluid" style="width: 160px;"  [alt]="language.passport">
                <div *ngIf="canUploadPassport">
                  <h6 *ngIf="showlimittext" style="text-align: center;" class="text-danger">{{limittext}}</h6>
                  <input *ngIf="togglepassportui" accept="image/png, image/jpeg" type="file"
                         (change)="onFileChange($event)" style="margin-top:8px" />

                  <button (click)="showwebcammodal()" class="d-flex justify-content-around align-items-center"
                       style="background-color: #74bbf7; width: 90%; padding-left: 2px; padding-right: 2px; margin: 5px auto; border-radius: 5px; cursor: pointer; border:none;"  [attr.aria-label]="language.openWebcamForPassport">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                    <p style="font-weight:bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">
                      {{language.takePicture}}
                    </p>
                  </button>
                </div>

                <!-- Video Instructions -->
                <div *ngIf="isInIframe()" class="candidate-video-div">
                  <video class="candidate-video" #candidateVideo playsinline autoplay muted></video>
                  <div class="text-center video-instructions">
                    <ul>
                      <li> <b>{{language.clearFaceInstruction}}</b></li>
                      <!-- <li> {{language.brightLightInstruction}}</li> -->
                    </ul>
                  </div>
                </div>
              </div>

              <div *ngIf="isInIframe()" style="display: none;" #candidateSecondViewVideoDiv>
                <video class="candidate-second-view-video" #candidateSecondViewVideo playsinline autoplay muted></video>
                <div class="text-center video-instructions">
                    <ul>
                      <li> <b>{{language.secondViewClarityInstruction}}</b></li>
                      <!-- <li> {{language.brightLightInstruction}}</li> -->
                    </ul>
                  </div>
              </div>

              <!-- Request Attention Button -->
              <!--If we're on a small screen, we have to hide the request attention button if there's a lot of stuff already in this div otherwise they won't see more important buttons-->
              <div id="request-attention-button-div" class="text-center">
                <button title="Requests Attention" (click)="raiseHandClicked()" class="btn btn-sm btn-primary p-1 m-2"
                        *ngIf="isProctorAssigned()">
                  {{language.requestAttention}}
                </button>
              </div>
            </div>
          </div>
          
          <div class="mt-auto d-flex flex-column">
            <!-- Examination Instruction Link -->
            <div *ngIf="showInstructionLink" class="text-center p-1" [ngClass]="{
              'mb-1': usecalc,
              'mb-2': !usecalc
            }" >
              <a href="javascript:void(0)" title="{{language.viewExamInstruction}}" (click)="toggleExaminationInstructionModal()" class="p-1 w-full text-decoration-underline">
                {{language.viewExamInstruction}}
              </a>
            </div>
          
            <!-- Toggle Calculator Button -->
            <div *ngIf="usecalc" class="text-center p-1 mb-2">
              <button title="Toggle Calculator" (click)="toggleCalculator()" class="btn btn-sm btn-primary p-1 w-full">
                <i class="fa fa-calculator fa-lg mr-2"></i>
                {{language.toggleCalculator}}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="col-md-8 col-lg-9 col-xl-9 right-div page-height-control" style="height: calc(100dvh - 4.375rem - {{sebQuitHeight}});">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>

<!-- Webcam Modal -->
<!-- <div class="modal fade camtake" id="webcammodal" tabindex="-1" data-keyboard='true' role="dialog"  aria-labelledby="webcammodalTitle"
  aria-modal="true"
  style="height: auto !important; margin: 5vw; "> -->
  <ng-template #passportCaptureModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="webcammodalTitle"
            [attr.aria-label]="language.takePicture">{{language.takePicture}}</h4>
            <button type="button" class="close" (click)="modal.dismiss('Close')" aria-label="Close passport photo dialog">
                <span aria-hidden="true">&times;</span>
            </button>
    </div>
    <div class="modal-body p-0">
      <app-webcam-passport style="height: 100% !important;" *ngIf="webcammode" [user]="this.user"
          (imagefile)="imagefilereceived($event)">
        </app-webcam-passport>
    </div>

  <!-- <div class="modal-dialog" role="document" style="max-width: 100% !important; height: 100%;">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="webcammodalTitle"> {{language.takePicture}}</h3>
        <button type="button" class="close h3" data-dismiss="modal" [attr.aria-label]="language.closeCapturePhotoDialog">&times;</button>
      </div>
      <div class="modal-body">
        <app-webcam-passport style="height: 100% !important;" *ngIf="webcammode" [examno]="this.user.username"
          (imagefile)="imagefilereceived($event)">
        </app-webcam-passport>
      </div>
    </div>
  </div> -->
</ng-template>
<!-- </div> -->
  <ng-template #logoutConfirmModal let-modal>
    <div class="modal-header">
      <h3 class="font-weight-bold text-uppercase" id="logoutConfirmModalTitle" [attr.aria-label]="language.logoutFromTheCurrentSession">
        {{language.logout}}
      </h3>
      <button type="button" class="close" (click)="modal.dismiss('Close')" aria-label="Close logout confirmation dialog">
        <span aria-hidden="true">&times;</span>
      </button>
      
    </div>
    <div class="modal-body p-3">
      <p class="text-black font-weight-bold text-center">{{language.logoutConfirmationMessage}}</p>
    </div>
    <div class="modal-footer  px-3 py-2">
      <button type="button" class="btn btn-secondary btn-lg p-2" (click)="modal.dismiss('Cancel')" >
        {{language.cancel}}
      </button>
      <button  class="btn btn-danger btn-lg p-2" (click)="modal.close('Logout')" routerLink="/logout" >
        {{language.logout}}
      </button>
    </div>
  </ng-template>